import { render, staticRenderFns } from "./receipt-mobile-smart-app-cta-banner.vue?vue&type=template&id=1ae4113f&scoped=true"
import script from "./receipt-mobile-smart-app-cta-banner.vue?vue&type=script&lang=ts"
export * from "./receipt-mobile-smart-app-cta-banner.vue?vue&type=script&lang=ts"
import style0 from "./receipt-mobile-smart-app-cta-banner.vue?vue&type=style&index=0&id=1ae4113f&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4113f",
  null
  
)

export default component.exports